import { getStage, Stage } from './Util'

/**
 * Stage-gated feature flags.
 *
 * Each flag maps every {@link Stage} to whether the feature is enabled, so a
 * change can be rolled out one stage at a time (beta -> gamma -> prod) instead
 * of all at once. Stage is derived from the hostname via {@link getStage}.
 *
 * To add a new flag, add one entry to {@link FEATURE_FLAGS}. The `defineFlags`
 * helper enforces that every stage is specified, and {@link FeatureFlag} is
 * derived from the keys automatically — no other edits needed. Then gate the
 * code with `isFeatureEnabled('YOUR_FLAG')`.
 */
const defineFlags = <T extends Record<string, Record<Stage, boolean>>>(flags: T): T => flags

const FEATURE_FLAGS = defineFlags({
    /**
     * Hides the "From Service" project creation flow as part of the
     * HeronServiceManagement deprecation (Phase 3). Existing service projects
     * remain viewable; only the creation entry point is hidden. Rolling out in
     * beta first.
     */
    HIDE_SERVICE_PROJECT_CREATION: {
        local: true,
        beta: true,
        gamma: true,
        prod: true,
    },
})

export type FeatureFlag = keyof typeof FEATURE_FLAGS

export const isFeatureEnabled = (flag: FeatureFlag): boolean => FEATURE_FLAGS[flag][getStage()]
